import { useQuery } from '@tanstack/react-query';
import { queryKeys, unwrap, type components } from '@geefamily/api';
import { api } from '@/app/api';

export type Site = components['schemas']['SiteResponse'];
export type SiteDetail = components['schemas']['SiteDetailResponse'];
export type Spotlight = components['schemas']['SpotlightResponse'];

const keys = queryKeys.module('catalog').entity('sites');

/**
 * The catalogue changes a few times a month and is cached server-side too, so a
 * long stale time here costs nothing and spares a request on every navigation.
 */
const StaleTime = 5 * 60_000;

export function useSites(featuredOnly = false) {
  return useQuery({
    queryKey: keys.list({ featured: featuredOnly }),
    queryFn: () =>
      unwrap<Site[]>(
        api.GET('/api/v1/catalog/sites', { params: { query: { featured: featuredOnly } } }),
      ),
    staleTime: StaleTime,
  });
}

export function useSpotlight() {
  return useQuery({
    queryKey: queryKeys.module('catalog').entity('spotlight').detail('current'),
    queryFn: () => unwrap<Spotlight>(api.GET('/api/v1/catalog/spotlight', {})),
    staleTime: StaleTime,
    // A 404 here means nothing is spotlit, which is a normal state, not a
    // failure worth retrying.
    retry: false,
  });
}
